





























import Vue from 'vue'
import dayjs from 'dayjs'
import { Notification } from '@/core/Notifications'
import ImportantBadge from './ImportantBadge.vue'

export default Vue.extend({
  name: 'Notification',
  components: {
    ImportantBadge,
  },
  filters: {
    dayFormat(value: string, format: string): string {
      return dayjs(value).format(format)
    },
  },
  props: {
    notification: {
      type: Object as () => Notification,
      default: null,
    },
  },
})
